// extracted by mini-css-extract-plugin
export default {"brandPromo":"PF-z","carousel":"QF-z"};